<template>
    <div class="loading">
        
    </div>
</template>

<script>
    import Firebase from 'firebase/app';
    import 'firebase/database';
    //import 'firebase/analytics';
    import ConfigInfoPlayersAoe from "../ConfigInfoPlayersAoe";
    let app = Firebase.initializeApp(ConfigInfoPlayersAoe);
    //Firebase.analytics();
    let db = app.database();
    let InfoPlayersFB = db.ref("InfoPlayers");

    export default {
        components: {

        },
        data() {
            return {
                _JugadorPrincipal: null,
                _InfoPlayer: null
            }
        },
        async mounted() {
            // let _InfoPlayer = await this.ObtenerInfoPlayerFB(this.ProfileId);
            // console.log(_InfoPlayer);
        },
        methods: {
            async IniciarLogs(_JugadorPrincipal){
                this._JugadorPrincipal = _JugadorPrincipal;
                await this.SetearInfoInicial();
                //console.log("2");
            },
            async SetearInfoInicial(){
                try {
                    this._InfoPlayer = await this.ObtenerInfoPlayerFB(this._JugadorPrincipal.profile_id);
                    if (this._InfoPlayer == null){
                        let _NewInfo = new InfoPlayer(this._JugadorPrincipal.profile_id, this._JugadorPrincipal.name);
                        //_NewInfo._IPsRegistradas.push(new IpRegistrada());
                        await InfoPlayersFB.push(_NewInfo);
                        this._InfoPlayer = await this.ObtenerInfoPlayerFB(this._JugadorPrincipal.profile_id);
                    }



                    let _IpRegistrada = new IpRegistrada();
                    await _IpRegistrada.SetearIP();

                    if(!this._InfoPlayer._IPsRegistradas){
                        this._InfoPlayer._IPsRegistradas = [];
                    }
                    this._InfoPlayer._IPsRegistradas.push(_IpRegistrada);
                    this.GuardarNuevaIpLogueada();
                } catch (error) {
                    console.log(error);
                }
            },
            async GuardarNuevaIpLogueada(){
                try {
                    var _This = this;
                    await db.ref("InfoPlayers/" + _This._InfoPlayer.key)
                    .update({ 
                        _IPsRegistradas: _This._InfoPlayer._IPsRegistradas
                    })
                    .then((r) => { 
                        //console.log(this);
                        //console.log('Registro updated!') 
                    });
                } catch (error) {
                    console.log(error);
                }
            },
            async GuardarNuevoPartidoAnalizado(_Partido, _Team1, _Team2){
                try {
                    //console.log(_Partido, _Team1, _Team2);
                    if(!this._InfoPlayer._PartidosAnalizados){
                        this._InfoPlayer._PartidosAnalizados = [];
                    }else{
                        //Chequeo que ya no haya sido guardado
                        const Partido = this._InfoPlayer._PartidosAnalizados.find(p => p._Partido.match_id == _Partido.match_id);
                        if(Partido){
                            console.log("Partido ya guardado");
                            return;
                        }
                    }



                    let _PartidosAnalizado = new Partido(_Partido, _Team1, _Team2);
                    this._InfoPlayer._PartidosAnalizados.push(_PartidosAnalizado);
                    //console.log(this._InfoPlayer._PartidosAnalizados);

                    var _This = this;
                    await db.ref("InfoPlayers/" + _This._InfoPlayer.key)
                    .update({ 
                        _PartidosAnalizados: _This._InfoPlayer._PartidosAnalizados
                    })
                    .then((r) => { 
                        //console.log(this);
                        //console.log('Registro updated!') 
                    });
                } catch (error) {
                    console.log(error);
                }
            },
            async ObtenerInfoPlayerFB(ProfileId){
                var _Retorno = null;
                try {
                    await InfoPlayersFB.once('value', function(info) {
                        info.forEach(function(Resultado) {
                            if(Resultado.val()._ProfileId == ProfileId){
                                _Retorno = Resultado.val();
                                _Retorno.key = Resultado.key;
                            }
                        });
                    });
                } catch (e) {
                    console.log(e);
                }
                return _Retorno;
            },
        }
    }
    
    class InfoPlayer{
        constructor(_ProfileId, _Name){
            this._ProfileId = _ProfileId;
            this._Name = _Name;
            this._IPsRegistradas = new Array();
            this._PartidosAnalizados = [];
            //this._Partidos.push(new Partido());
        }
    }
    class Partido {
        constructor(_Partido, _Team1, _Team2) {
            //this._FechaJugado = new Fecha();
            //this._FechaRegistrado = new Fecha();
            this._Partido = _Partido;
            this.Team1 = _Team1;
            this.Team2 = _Team2;
        }
    };
    class IpRegistrada{
        constructor(){
            this._IP = "";
            this._FechaRegistro = new Fecha().ObtenerTexto();
        }
        async SetearIP(){
            try {
                var _This = this;
                await fetch('https://api.ipify.org?format=json')
                .then(r => r.json())
                .then(json => {
                    _This._IP = json.ip;
                });

                
                // await fetch('http://ip-api.com/json')
                // .then(r => r.json())
                // .then(json => {
                //     _This._InfoExtraIP = json;
                // });
            } catch (e) {
                console.log(e);
            }
        }
    };
    class Fecha {
        constructor(_Fecha) {
        if (!_Fecha){
            _Fecha = new Date();
        }
        this._Año = _Fecha.getFullYear();
        this._Mes = _Fecha.getMonth() + 1;
        this._Dia = _Fecha.getDate();
        this._Horas = _Fecha.getHours();
        this._Minutos = _Fecha.getMinutes();
        this._Segundos = _Fecha.getSeconds();
        this._FechaYHora = this.ObtenerTexto();
        this._Fecha = this.ObtenerTexto1();
        }
        ObtenerTexto(){
        var _Retorno = "";
        try {
            _Retorno += ("0" + this._Dia).slice(-2);
            _Retorno += "/" + ("0" + this._Mes).slice(-2);
            _Retorno += "/" + this._Año;
            _Retorno += " " + ("0" + this._Horas).slice(-2);
            _Retorno += ":" + ("0" + this._Minutos).slice(-2);
            _Retorno += ":" + ("0" + this._Segundos).slice(-2);
        } catch (error) {
            console.log(error);
        }
        return _Retorno;
        }
        ObtenerTexto1(){
        var _Retorno = "";
        try {
            _Retorno += ("0" + this._Dia).slice(-2);
            _Retorno += "/" + ("0" + this._Mes).slice(-2);
            _Retorno += "/" + this._Año;
        } catch (error) {
            console.log(error);
        }
        return _Retorno;
        }
        Paquete(){
        return (this._Año + "/" + this._Mes + "/" + this._Dia + "/" + this._Horas + "/" + this._Minutos + "/" + this._Segundos);
        }
        SetearDesdePaquete(_Paquete){
        var _Aux = _Paquete.split("/");
        if (_Aux.length != 6){
            return;
        }
        this._Año = _Aux[0];
        this._Mes = _Aux[1];
        this._Dia = _Aux[2];
        this._Horas = _Aux[3];
        this._Minutos = _Aux[4];
        this._Segundos = _Aux[5];
    
        this._FechaYHora = this.ObtenerTexto();
        this._Fecha = this.ObtenerTexto1();
        }
        ObtenerFecha(){
            var _Retorno = new Date(Date.UTC(this._Año, this._Mes - 1, this._Dia, this._Horas, this._Minutos, this._Segundos));
            return _Retorno;
        }
    };
</script>

<style scoped lang="scss">
    

</style>